import { useEffect, useState } from "react";
import {
   getPackagesRedirectUrl,
   getSearchPayload,
   getSearchPayloadCarHire,
   getSearchPayloadExperience,
   getSearchPayloadHotel,
   getSearchPayloadTransfer,
   getSupplierUrl,
   hexToRgbA,
   submitSearch,
} from "./utils";
import EasyOTAFormExperience from "./forms/EasyOTAFormExperience";
import EasyOTAFormSafaris from "./forms/EasyOTAFormSafaris";
import EasyOTAFormHotel from "./forms/EasyOTAFormHotel";
import EasyOTAFormCarHire from "./forms/EasyOTAFormCarHire";
import PlaceholderForm from "./forms/PlaceholderForm";
import EasyOTAFormTransfer from "./forms/EasyOTAFormTransfer";
import EasyOTAFormFlight from "./forms/EasyOTAFormFlight";

function App() {
   const [supplier, setSupplier] = useState();
   const [error, setError] = useState("");
   const [selectedTab, setSelectedTab] = useState();
   useEffect(() => {
      let url = getSupplierUrl();
      const getSupplier = async (refetch = 0) => {
         try {
            let data = await (await fetch(url)).json();
            setSupplier({
               data: { ...data.cosmetics },
               tabs: data.tabs,
               products: data.productTypes,
               locations: data.locations,
               settings: data.settings,
            });
         } catch (error) {
            console.log(`Error fetching information(${refetch}): `, error);
            if (refetch <= 5) {
               console.log("Attempt to refetch");
               setTimeout(() => {
                  console.log("Refetching ...");
                  getSupplier(refetch + 1);
               }, 200);
            } else {
               setError(`Something went wrong. Failed to fetch supplier details`);
            }
         }
      };

      getSupplier();
   }, []);
   useEffect(() => {
      if (supplier) {
         let d = supplier.data;
         let colors = {
            baseColor: d.baseColour,
            linkColor: d.linkForeColour,
            widgetColor: d.widgetHeaderColour,
         };
         let root = document.querySelector("#easyota-form-plugin-react");
         function updateClr(prop, color, opacity = 1) {
            if (color === "") {
               color = getComputedStyle(root).getPropertyValue(prop);
            }
            if (color !== "") {
               try {
                  root.style.setProperty(prop, hexToRgbA(color, opacity));
               } catch (error) {
                  root.style.setProperty(prop, color);
               }
            }
         }

         updateClr("--easyota-base-color", colors.widgetColor, 0.7);
         updateClr("--easyota-search-color", colors.widgetColor);
         updateClr("--easyota-tabs-color", colors.baseColor, 0.5);
         updateClr("--easyota-tabs-active-color", colors.baseColor);
      }
   }, [supplier]);
   const handleSubmit = (data) => {
      let currentTab = sortedTabs.find((t) => t.id === (selectedTab || sortedTabs[0].id));
      console.log("Data: ", data);
      let product = currentTab.productType;
      let supplierId = supplier.data.supplierId;
      let productId = product.id;
      if (product.productName === "Package") {
         console.log("Raw redirect: ", data);
         let params = {
            fromDate: data.departure_date,
            rooms: data.rooms,
            ...data.travellers,
         };
         let redirectUrl = getPackagesRedirectUrl(params);
         setTimeout(function () {
            console.log("Url: ", redirectUrl);
            window.location.href = redirectUrl;
         }, 100);
         return;
      }
      let request = null;
      if (["Hotel"].includes(product.productName)) {
         let supplierLoc = supplier.locations ? supplier.locations[0] : null;
         data = { ...data, supplierLoc };
         console.log("Supplier Location", supplierLoc, supplier.locations);
         request = getSearchPayloadHotel(supplierId, productId, data);
      } else if (["Car Hire"].includes(product.productName)) {
         let supplierLoc = supplier.locations ? supplier.locations[0] : null;
         data = { ...data, supplierLoc };
         console.log("Supplier Location", supplierLoc, supplier.locations);
         request = getSearchPayloadCarHire(supplierId, productId, data);
      } else if (["Transfer"].includes(product.productName)) {
         let supplierLoc = supplier.locations ? supplier.locations[0] : null;
         data = { ...data, supplierLoc };
         console.log("Supplier Location", supplierLoc, supplier.locations);
         request = getSearchPayloadTransfer(supplierId, productId, data);
      } else if (["Experience"].includes(product.productName)) {
         let showActs = supplier.settings.showDestinationActivities;
         let searchLoc = showActs ? undefined : { id: data.location.id };
         let supplierLoc = showActs ? { id: data.location.id } : supplier.locations[0];
         data = { ...data, supplierLoc };
         console.log("Supplier Location", { supplierLoc, supplier });
         request = getSearchPayloadExperience(supplierId, productId, data, supplierLoc, searchLoc);
      } else {
         request = getSearchPayload(supplierId, productId, data);
      }

      console.log("Request: ", request);
      submitSearch(request, setError);
   };
   let supplierId = supplier ? supplier.data.supplierId : null;
   if (error) {
      return (
         <section className='easyota-form-plugin'>
            <div className=''>
               <p className='loading error'>{error}</p>
            </div>
         </section>
      );
   }

   if (!supplier) {
      return <PlaceholderForm />;
   }

   let sortedTabs = supplier.tabs
      .filter((t) => t.showWidget)
      .sort((p1, p2) => {
         let p1Order = parseInt(p1.tabOrder);
         let p2Order = parseInt(p2.tabOrder);
         return p1Order < p2Order ? -1 : p1Order > p2Order ? 1 : 0;
      });

   let currentTab = sortedTabs.find((t) => t.id === (selectedTab || sortedTabs[0].id));
   const TabForm = () => {
      let supplierLoc = supplier.locations ? supplier.locations[0] : null;
      let prodName = currentTab.productType.productName;
      if (prodName === "Flight")
         return (
            <EasyOTAFormFlight supplierSettings={supplier.settings} supplierId={supplierId} onSubmit={handleSubmit} />
         );
      if (prodName === "Transfer")
         return (
            <EasyOTAFormTransfer
               supplierSettings={supplier.settings}
               supplierLoc={supplierLoc}
               supplierId={supplierId}
               onSubmit={handleSubmit}
            />
         );
      if (prodName === "Car Hire")
         return (
            <EasyOTAFormCarHire supplierSettings={supplier.settings} supplierId={supplierId} onSubmit={handleSubmit} />
         );
      if (prodName === "Hotel")
         return supplierLoc ? (
            <EasyOTAFormHotel supplierSettings={supplier.settings} supplierId={supplierId} onSubmit={handleSubmit} />
         ) : (
            <p>This supplier does not have location configured</p>
         );
      if (prodName === "Package")
         return supplierLoc ? (
            <EasyOTAFormSafaris
               supplierSettings={supplier.settings}
               supplierLoc={supplierLoc}
               supplierId={supplierId}
               onSubmit={handleSubmit}
            />
         ) : (
            <p>This supplier does not have location configured</p>
         );
      if (prodName === "Experience") {
         let found = supplier.products.find((p) => p.id === currentTab.productType.id);
         console.log({ found });
         return supplierLoc ? (
            <EasyOTAFormExperience
               supplierSettings={supplier.settings}
               supplierLoc={supplierLoc}
               onSubmit={handleSubmit}
               supplierId={supplierId}
               product={found}
            />
         ) : (
            <p>This supplier does not have location configured</p>
         );
      }

      return (
         <p>
            Widget for <b>{prodName}</b>, is not implemented yet!
         </p>
      );
   };

   console.log({ sortedTabs });
   return (
      <section className='easyota-form-plugin'>
         <div className='form-wrap'>
            {error && <div className='error'>{error}</div>}
            {sortedTabs.length > 1 && (
               <div className='tabs'>
                  {sortedTabs.map((t, idx) => (
                     <button
                        key={idx}
                        className={`item${currentTab.id === t.id ? " active" : ""}`}
                        onClick={() => setSelectedTab(t.id)}
                     >
                        {t.tabName || t.productType.productName}
                     </button>
                  ))}
               </div>
            )}
            <TabForm />
         </div>
      </section>
   );
}

export default App;
